import './ProfileDetails.css';
import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonListHeader, IonPage, IonToolbar } from "@ionic/react";
import { arrowBackCircleOutline, arrowBackOutline, closeOutline } from "ionicons/icons";
import { useGetUserInfoQuery } from "../../../services/api/ebioro/ebioro";
import { useAppSelector } from '../../../services/redux/hook';
import AppHeader from '../../../components/AppHeader/AppHeader';
import { useTranslation } from 'react-i18next';
import { App, BackButtonListenerEvent } from '@capacitor/app';

// type MyModalProps = {

//     closeAction: Function;

// }

const ProfileDetailsPage: React.FC = () => {

	const { t, i18n } = useTranslation();

	const ebioroAuthDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';
	const sep10Tokens = useAppSelector((state) => state.sep10AuthToken.tokens);
	const { data: userInfo } = useGetUserInfoQuery(sep10Tokens[ebioroAuthDomain]);
	const nav = document.querySelector("ion-nav");

	// dealing with android back button and modals
	App.addListener('backButton', (ev: BackButtonListenerEvent) => {
		nav?.pop()
	});

	return (
		<IonPage>
			<IonHeader className="ion-no-border">
				<IonToolbar >
					<IonButtons slot="start">
						<IonButton onClick={() => { nav?.pop() }} color='primary'>
							<IonIcon slot="icon-only" icon={arrowBackOutline} />
						</IonButton>
					</IonButtons>
				</IonToolbar>
				<AppHeader

					title={t('profile.page.details.HEADER') as string}>
				</AppHeader>
			</IonHeader>
			<IonContent>

				<IonCard>

					<IonCardContent>
						
							<div hidden={!userInfo?.first_name}>
								<IonListHeader className='profile_details_listHeader ion-text-start' >
									<IonLabel >{t('profile.page.details.FULL_NAME-LABEL')}</IonLabel>
								</IonListHeader>
								<IonItem lines='none'>
									<IonLabel>{`${userInfo?.first_name} ${userInfo?.last_name}`} </IonLabel>
								</IonItem>
							</div>

							<div >
								<IonListHeader className='profile_details_listHeader ion-text-start'>
									<IonLabel >{t('profile.page.details.EMAIL-LABEL')}</IonLabel>
								</IonListHeader>
								<IonItem lines='none'>
									<IonLabel> {userInfo?.email}</IonLabel>
									{
										userInfo?.is_email_verified ?

											<IonLabel

												color="success"

												slot='end'>{t('profile.page.details.EMAIL-LABEL-VERIFIED')}</IonLabel>
											:
											<></>


									}
								</IonItem>
							</div>
							<div >
								<IonListHeader className='profile_details_listHeader ion-text-start'>
									<IonLabel >{t('profile.page.details.MOBILE-LABEL')}</IonLabel>
								</IonListHeader>
								<IonItem lines='none'>
									<IonLabel> {userInfo?.mobile_number}</IonLabel>
									{
										userInfo?.is_mobile_number_verified ?

											<IonLabel

												color="success"

												slot='end'>{t('profile.page.details.MOBILE-LABEL-VERIFIED')}</IonLabel>
											:
											<></>


									}

								</IonItem>
							</div>
						
					</IonCardContent>


				</IonCard>

			</IonContent>

		</IonPage>
	);
};

export default ProfileDetailsPage;
